import { useGetContextOrError } from '@/lib/hooks/use-get-context-or-error';

import { context } from './context';

export const useResourceHubState = () =>
  useGetContextOrError(context, 'Resource Hub State');
